import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export enum Status {
    ACTIVE = 'ACTIVE',
    EDITED = 'EDITED',
    DELETED = 'DELETED',
    ATTACHED = 'ATTACHED',
};

@Injectable({
    providedIn: 'root',
})
export class ChatsService {

	constructor(
		public apiService: ApiService,
	) {
	}

  createChatMessage( receiver_id: any, message: string, chat_id: any, token: string) {

    var body: any;

    body = {receiver_id: receiver_id, message: message, chat_id: chat_id};
    console.log(body);

    return this.apiService.post('/chats/create', body, token).pipe(response => response);

  }

  updateChatMessage(id: any, message: string, token: string) {

    var body: any;

    body = {id: id, message: message};

    return this.apiService.post('/chats/update', body, token).pipe(response => response);

  }

  deleteChatMessage( id: any, token: string ) {

    var body: any;

    body = {id: id.toString()};

    return this.apiService.post('/chats/delete', body, token).pipe(response => response);

  }

  getChats(page: number, token: string) {

    var body: any;

    body = {};

    return this.apiService.get('/chats/listChats?page=' + page, body, token).pipe(response => response);

  }

  getMessage( id: any, token: string ) {

		var body: any;

		body = {id: id.toString()};

		return this.apiService.get('/chats/read', body, token).pipe(response => response);

  }

  getChatMessages(id: any, token: string) {

    var body: any;

  	body = {id: id.toString()};

    return this.apiService.get('/chats/listMessages', body, token).pipe(response => response);

  }

  getChatMessagesByUser(id: any, token: string) {

    var body: any;

	  body = {id: id.toString()};

    return this.apiService.get('/chats/listMessagesByUser', body, token).pipe(response => response);

  }

  getChatMessagesUnread(id: any, token: string) {

    var body: any;

	  body = {id: id.toString()};

    return this.apiService.get('/chats/listMessagesUnread', body, token).pipe(response => response);

  }

  getChatMessagesChanged(id: any, token: string) {

    var body: any;

	  body = {id: id.toString()};

    return this.apiService.get('/chats/listMessagesChanged', body, token).pipe(response => response);

  }

	getMessagesCounter( token: string ) {

		var body: any;

		body = {};

		return this.apiService.get('/chats/counter', body, token).pipe(response => response);

	}

  //targetLanguage: language of the receiver
	translateMessage( id: any, message: string, target_lang: string, token: string ) {

		var body: any;

		body = {id: id, message: message, target_lang: target_lang};

		return this.apiService.get('/chats/translate', body, token).pipe(response => response);

	}

}